// eslint-disable-next-line import/no-restricted-paths
import { Host } from "@CHILLNN-Inc/chillnn-driver-reservation-react";
import { memo, useMemo } from "react";
import { generatePath, useNavigate } from "react-router";

import { AuthWrapper } from "@/lib/aws-amplify";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

type Props = {
	hotelID: string;
	reservationID: string;
};

const uri = import.meta.env.VITE_GRAPHQL_API_ENDPOINT_RESERVATION_HOST;

export const ManagementReservationEdit = memo(({ hotelID, reservationID }: Props) => {
	const navigate = useNavigate();

	const sessionStateContext = useMemo<Host.ReservationComponent.PriceEditable.Props["sessionStateContext"]>(() => {
		return {
			hotelID,
			reservationID,
		};
	}, [hotelID, reservationID]);

	const callbackContext = useMemo<Host.ReservationComponent.PriceEditable.Props["callbackContext"]>(() => {
		const handleSuccess = () => {
			notifyUserEventInfo({
				variant: "default",
				title: "予約情報を更新しました",
			});

			const reservationDetailPagePath = generatePath(PATHS.HOTEL.MANAGEMENT.RESERVATION.DETAIL, {
				hotelID,
				reservationID,
			});
			navigate(reservationDetailPagePath, { replace: true });
		};

		return {
			onSuccessCallback: handleSuccess,
		};
	}, [hotelID, navigate, reservationID]);

	const libContext = useMemo<Host.ReservationComponent.PriceEditable.Props["libContext"]>(() => {
		return {
			apolloClient: {
				uri,
				getToken: async () => (await AuthWrapper.getIdToken()) ?? "",
			},
		};
	}, []);

	const envContext = useMemo<Host.ReservationComponent.PriceEditable.Props["envContext"]>(() => {
		return {
			stage: import.meta.env.VITE_STAGE,
			user: "host",
		};
	}, []);

	return (
		<Host.ReservationComponent.PriceEditable.Presenter
			sessionStateContext={sessionStateContext}
			callbackContext={callbackContext}
			libContext={libContext}
			envContext={envContext}
		/>
	);
});
